const mboxRequest = {
    request: {
        execute: {
            pageLoad: {
            	options: []
            }
        }
    }
};

const getMboxes = () => {
    return new Promise((resolve) => {
        const adobeEnabled = window?.adobe?.target?.getOffer;
    
        if (!adobeEnabled) {
            return resolve({});
        }

        window.adobe.target.getOffers(mboxRequest).then((response) => {
            const mboxOptions = response.execute?.pageLoad?.options || [];
            let temp = {};
            
            for (let i =0; i < mboxOptions.length; i++) {
                const content = mboxOptions[i]?.content;
                if (content) {
                    const testName = Object.keys(content)?.[0];
                    if (testName) {
                        temp[testName] = content[testName];
                    }
                }
            }

            return resolve(temp);
        }).catch((error) => {
            console.error('GD TT: adobe target error');
        });
    });
};


async function getAdobeTarget() {
    return await getMboxes();
}

const initAdobeTarget = () => {
    return getAdobeTarget()
        .then((responses) => {
            return responses;
        })
        .catch((error) => {
            console.error('GD TT: error from getAdobeTarget', error);
            return {};
        });
};


export default initAdobeTarget;

